import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  DuplicateFilingSubmissionStatus,
  DuplicateTradingPlanEntry,
  DuplicateTradingPlansEntryDetails,
  QualityGateDetailsFilter,
  QualityGateFilter, QualityGateSubmission
} from 'src/api/models';
import { QualityGateService } from 'src/api/services';

@Component({
  selector: 'app-view-duplicate-plans-filings',
  // imports: [],
  templateUrl: './view-duplicate-plans-filings.component.html',
  styleUrl: './view-duplicate-plans-filings.component.css',
  standalone:false
})
export class ViewDuplicatePlansFilingsComponent implements OnInit{
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  selectedFiling: any;
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  planData: any;
  unprocessedDuplicatePlansEntries: DuplicateTradingPlansEntryDetails[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef

  ) {}

  ngOnInit(): void {
     this.planData = this.config.data;
    this.selectedFiling = this.config.data;
     console.log('test1',this.planData);
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedDuplicatePlans();
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedDuplicatePlans();
  }
  getUnprocessedDuplicatePlans() {
    const params: QualityGateDetailsFilter = {
      entryId: this.planData.entryId,
      qualityGateType: "Duplicate_Trading_Plan"
    };
    this.isLoading = true;
    console.log('test12', params);
    this._qualityGateService.viewEntryDetails(params).subscribe({
      next: (value) => {
        console.log('check1', value);
        this.unprocessedDuplicatePlansEntries = value.duplicateTradingPlanEntryDetails ?? [];
        console.log('check', this.unprocessedDuplicatePlansEntries);
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount = 10
        this.isLoading = false;
      },
    });
  }
  openDuplicatePlansFilingModal(share: any) {
   const selectedData = share;
    this.ref = this.dialogService.open(ViewDuplicatePlansFilingsComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
       header: 'View Duplicate Plan Filing',
       data: selectedData,
    });
    this.ref.onClose.subscribe(() => {

    });
  }

  onExcludeClick(share: any, status: string) {
    console.log(share,status);
    const submission: QualityGateSubmission = {
      qualityGateType: "Duplicate_Trading_Plan",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      duplicateTradingPlanSubmission: {
        entryId: share.entryId,
        entryDetailsId: share.entryDetailsId,
        status:
          status == "EXCLUDED"
            ? DuplicateFilingSubmissionStatus.EXCLUDED
            : DuplicateFilingSubmissionStatus.DUPLICATE,
      }
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        // Refresh list from server
        this._qualityGateService
          .viewEntryDetails({
            qualityGateType: "Duplicate_Trading_Plan",
            entryId: this.planData.entryId,
          })
          .subscribe((value) => {
            this.unprocessedDuplicatePlansEntries =
              value.duplicateTradingPlanEntryDetails  ?? [];

            // ✅ Now check only after user action
            const allProcessed = this.unprocessedDuplicatePlansEntries.every(
              (item) =>
                item.status === "EXCLUDED" || item.status === "DUPLICATE"
            );

            if (allProcessed) {
              this.ref.close({ refresh: true });
            }
          });
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }



}




